const getCsvData = (): any => {
  const allExportParameterNames = window.GetAllExportParameters();
  return window.ExportData(
    { exportDataFilter: '' },
    window.GetExportDataObject(allExportParameterNames),
    allExportParameterNames
  );
};

export default getCsvData;
